import { useState } from "react";
import { Facebook, Instagram, MessageCircle, Link2, Check, Share2 } from "lucide-react";
import { toast } from "sonner";

const copy = async (url) => {
  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = url;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    let ok = false;
    try { ok = document.execCommand("copy"); } catch { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }
};

export const ShareBar = ({ url, title, compact = false, testid = "share-bar" }) => {
  const [copied, setCopied] = useState(false);
  const text = `${title} — Speedy Resurfacing`;
  const canNative = typeof navigator !== "undefined" && !!navigator.share;

  const onInstagram = async () => {
    if (canNative) {
      try { await navigator.share({ title, text, url }); return; } catch { /* user cancelled */ }
    }
    if (await copy(url)) toast.success("Link copied — paste it into your Instagram story, bio or DM.");
    else toast.error("Couldn't copy the link — long-press the address bar instead.");
  };

  const onCopy = async () => {
    if (await copy(url)) {
      setCopied(true);
      toast.success("Article link copied.");
      setTimeout(() => setCopied(false), 2200);
    } else toast.error("Couldn't copy the link.");
  };

  const btn = `inline-flex items-center justify-center gap-2 rounded-full border border-white/12 bg-white/[0.04] font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-200 transition-colors duration-200 hover:border-[color:var(--accent)] hover:text-white hover:bg-[color:var(--accent-soft)] ${compact ? "h-11 w-11" : "h-11 px-4"}`;

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testid}>
      {!compact && (
        <span className="mr-1 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
          <Share2 size={13} /> Share
        </span>
      )}
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer"
         className={btn} aria-label="Share on Facebook" data-testid={`${testid}-facebook`}>
        <Facebook size={16} />{!compact && "Facebook"}
      </a>
      <a href={`https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`} target="_blank" rel="noopener noreferrer"
         className={btn} aria-label="Share on WhatsApp" data-testid={`${testid}-whatsapp`}>
        <MessageCircle size={16} />{!compact && "WhatsApp"}
      </a>
      <button type="button" onClick={onInstagram} className={btn} aria-label="Share to Instagram" data-testid={`${testid}-instagram`}>
        <Instagram size={16} />{!compact && "Instagram"}
      </button>
      <button type="button" onClick={onCopy} className={btn} aria-label="Copy article link" data-testid={`${testid}-copy`}>
        {copied ? <Check size={16} className="text-gold" /> : <Link2 size={16} />}{!compact && (copied ? "Copied" : "Copy link")}
      </button>
    </div>
  );
};
